import { StyleProp } from "@mantine/core";
import { MapGeoJSONFeature } from "react-map-gl/maplibre";
import OverflowTooltip from "../OverflowTooltip";

interface FeeInfoProps {
  campground: MapGeoJSONFeature;
  ta?: StyleProp<React.CSSProperties["textAlign"] | undefined>;
}

const FeeInfo = ({ campground, ta }: FeeInfoProps) => {
  const feeProp = campground.properties?.fee;
  const chargeProp = campground.properties?.charge;

  let color = "dimmed";
  let feeText = "fee unk.";
  if (feeProp !== undefined) {
    if (feeProp === "no") {
      feeText = "no fee";
      color = "green.7";
    } else if (feeProp === "yes") {
      feeText = "fee rqd.";
      color = "red.4";
      if (chargeProp !== undefined) {
        feeText = `${chargeProp}`;
      }
    }
  }

  return (
    <OverflowTooltip c={color} size="sm" ta={ta ? ta : "right"} w="100%">
      {feeText}
    </OverflowTooltip>
  );
};

export default FeeInfo;
